module.exports = __webpack_public_path__ + "img/icon_yejiao_logo.d17a72cc.png";